interface ExcludeJumpersCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const EXCLUDE_JUMPERS_HINT = 'Кандидаты, которые на последних 3 местах работы работали менее 12 месяцев';

export function ExcludeJumpersCheckbox({ checked, onChange }: ExcludeJumpersCheckboxProps) {
  return (
    <label className="flex items-start gap-2 cursor-pointer">
      <input
        type="checkbox"
        data-testid="vacancy-exclude-jumpers"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 w-4 h-4 rounded border-[#e2e4e9]"
      />
      <span className="flex flex-col gap-1">
        <span className="text-sm">Исключить кандидатов-джамперов</span>
        <span
          data-testid="vacancy-exclude-jumpers-hint"
          className="break-words text-xs leading-4 text-[#868c98]"
        >
          {EXCLUDE_JUMPERS_HINT}
        </span>
      </span>
    </label>
  );
}
